import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import { useLenis } from "./hooks/useLenis";
import Preloader from "./components/Preloader";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Manifesto from "./components/Manifesto";
import Marquee from "./components/Marquee";
import Music from "./components/Music";
import VideoReel from "./components/VideoReel";
import Gallery from "./components/Gallery";
import CityShow from "./components/CityShow";
import Contact from "./components/Contact";
import NoteCursor from "./components/NoteCursor";

function App() {
  const [loaded, setLoaded] = useState(
    typeof window !== "undefined" && window.location.search.includes("nopreload")
  );
  useLenis();

  return (
    <div className="App grain">
      <NoteCursor />
      <AnimatePresence>
        {!loaded && <Preloader onDone={() => setLoaded(true)} />}
      </AnimatePresence>

      <Nav />
      <main>
        <Hero start={loaded} />
        <Manifesto />
        <Marquee />
        <Music />
        <VideoReel />
        <Gallery />
        <CityShow />
        <Contact />
      </main>
    </div>
  );
}

export default App;
